import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./DadosCliente.css";

import Navbar from "../../../components/parts/navbar/Navbar";
import TopLinks from "../../../components/parts/TopLinks/TopLinks";
import Menu from "../../../components/parts/menu/Menu";
import Footer from "../../../components/parts/footer/Footer";
import BTNtoTop from "../../../components/parts/BTNtoTop/BTNtoTop";
//import Imagens from "../../../components/IMAGESCOMPONENT/ImageComponent";
import VerificaToken from "../../../components/utils/VerificaToken";
import ClienteTabs from "../../../components/parts/ClienteTabs/ClienteTabs";
import AlterarSenha from "./AlterarSenha/AlterarSenha";

export default function DadosCliente() {

    const [modalSenha, setModalSenha] =
        useState(false);

    const [codcliente, setCodcliente] = useState(null);

    const navigate = useNavigate();

    const [menuOpen, setMenuOpen] = useState(false);

    const [loading, setLoading] = useState(true);

    const [editando, setEditando] = useState(false);

    const [mensagem, setMensagem] = useState("");
    const [tipoMensagem, setTipoMensagem] =
        useState("");

    const [dadosOriginais, setDadosOriginais] =
        useState({});

    const [pendencias, setPendencias] =
        useState({});

    const [form, setForm] = useState({
        codcliente: "",
        nomecliente: "",
        endereco: "",
        numero: "",
        cidade: "",
        pais: "",
        estado: "",
        cep: "",
        bairro: "",
        fone: "",
        inscestadual: "",
        cgc: "",
        cpf: "",
        email: "",
        razaosocial: "",
        contato: "",
        codplano: "",
        codrepresentante: "",
    });

    useEffect(() => {
        async function iniciar() {
            const usuario = await VerificaToken();

            if (!usuario.login) {
                navigate("/");
                return;
            }

            setCodcliente(usuario.codcliente);

            // use o valor retornado pelo token
            await carregarDados(usuario.codcliente);
        }

        iniciar();
    }, [navigate]);


    async function carregarDados(codcliente) {
        try {
            setLoading(true);

            const res = await axios.post(
                "https://app.eliandroalimentos.com.br/api/cliente/listardadoscliente",
                {
                    codcliente,
                }
            );

            const dados = res.data.DadosCliente;
            console.log("dados", dados)
            const edicao =
                res.data.ParaEdicaoCliente || {};

            setPendencias(edicao);

            const novoForm = {
                codcliente: dados.codcliente,
                nomecliente: edicao.nomecliente ?? dados.nomecliente,
                endereco: edicao.endereco ?? dados.Endereco,
                numero: edicao.numero ?? dados.Numero,
                cidade: edicao.cidade ?? dados.Cidade,
                pais: edicao.pais ?? dados.pais,
                estado: edicao.estado ?? dados.estado,
                cep: edicao.cep ?? dados.cep,
                bairro: edicao.bairro ?? dados.Bairro,
                fone: edicao.fone ?? dados.fone,
                inscestadual:
                    edicao.inscestadual ??
                    dados.inscestadual,
                cgc: edicao.cgc ?? dados.cgc,
                cpf: edicao.cpf ?? dados.cpf,
                razaosocial:
                    edicao.razaosocial ??
                    dados.razaosocial,
                contato:
                    edicao.contato ??
                    dados.contato,
                codplano:
                    edicao.codplano ??
                    dados.codplano,
                codrepresentante:
                    edicao.codrepresentante ??
                    dados.codrepresentante,
                email: edicao.Email ?? dados.Email,
            };

            setForm(novoForm);
            setDadosOriginais(novoForm);
        } catch (err) {
            console.error(err);

            setMensagem("Erro ao carregar dados.");
            setTipoMensagem("erro");
        } finally {
            setLoading(false);
        }
    }

    function alterarCampo(
        campo,
        valor
    ) {
        setForm({
            ...form,
            [campo]: valor,
        });
    }

    function handleEditar() {
        setEditando(true);
    }

    function cancelar() {
        setForm(dadosOriginais);

        setEditando(false);

        setMensagem("");
    }

    async function salvar() {
        try {
            const body = {
                codcliente: dadosOriginais.codcliente,
            };

            Object.keys(form).forEach(
                (campo) => {
                    if (
                        campo !==
                        "codcliente" &&
                        form[campo] !==
                        dadosOriginais[
                        campo
                        ]
                    ) {
                        body[campo] =
                            form[campo];
                    }
                }
            );

            if (
                Object.keys(body)
                    .length === 1
            ) {
                setTipoMensagem(
                    "erro"
                );

                setMensagem(
                    "Nenhuma alteração realizada."
                );

                return;
            }

            await axios.put(
                "https://app.eliandroalimentos.com.br/api/cliente/solicitaedicaocliente",
                body
            );

            setTipoMensagem(
                "sucesso"
            );

            setMensagem(
                "Solicitação enviada com sucesso."
            );

            setEditando(false);

            await carregarDados(codcliente);
        } catch (err) {
            console.error(err);

            setTipoMensagem(
                "erro"
            );

            setMensagem(
                "Erro ao enviar solicitação."
            );
        }
    }

    function renderCampo(
        label,
        campo
    ) {
        return (
            <div className="input-group">
                <label>
                    {label}

                    {pendencias[campo] && (
                        <span
                            className="pendente-icon"
                            title="Existe uma solicitação pendente para este campo."
                        >
                            ⚠
                        </span>
                    )}
                </label>

                <input
                    value={
                        form[campo] ?? ""
                    }
                    disabled={!editando}
                    onChange={(e) =>
                        alterarCampo(
                            campo,
                            e.target.value
                        )
                    }
                />
            </div>
        );
    }

    if (loading) {
        return (
            <div className="primeiro-wrapper">
                Carregando...
            </div>
        );
    }

    return (
        <>
            <Navbar />

            <TopLinks
                onOpenMenu={() =>
                    setMenuOpen(true)
                }
            />

            <Menu
                isOpen={menuOpen}
                onClose={() =>
                    setMenuOpen(false)
                }
            />
            <ClienteTabs />

            <div className="primeiro-wrapper">



                <div className="primeiro-card">



                    <div className="titulo-dados">

                        <h2>Dados da Empresa</h2>

                        <button
                            className="btn-alterar-senha"
                            onClick={() => setModalSenha(true)}
                        >
                            🔑 Alterar Senha
                        </button>

                    </div>

                    <div className="primeiro-form">

                        <div className="form-grid">

                            <div className="form-column">



                                {renderCampo(
                                    "Nome Fantasia",
                                    "nomecliente"
                                )}

                                {renderCampo(
                                    "Razão Social",
                                    "razaosocial"
                                )}

                                <div className="linha-dupla">

                                    <div className="campo-cnpj">
                                        {form.cgc
                                            ? renderCampo("CNPJ", "cgc")
                                            : renderCampo("CPF", "cpf")}
                                    </div>

                                    <div className="campo-inscricao">
                                        {renderCampo(
                                            "Inscrição Estadual",
                                            "inscestadual"
                                        )}
                                    </div>

                                </div>

                                 {renderCampo(
                                    "CEP",
                                    "cep"
                                )}

                                <div className="linha-dupla">

                                    <div className="campo-contato">
                                        {renderCampo(
                                            "Contato",
                                            "contato"
                                        )}
                                    </div>

                                    <div className="campo-telefone">
                                        {renderCampo(
                                            "Telefone",
                                            "fone"
                                        )}
                                    </div>

                                </div>

                               

                            </div>

                            <div className="form-column">

                                {renderCampo(
                                    "Endereço",
                                    "endereco"
                                )}

                                <div className="linha-dupla">
                                    <div className="campo-numero">
                                        {renderCampo(
                                            "Número",
                                            "numero"
                                        )}
                                    </div>

                                    <div className="campo-bairro">
                                        {renderCampo(
                                            "Bairro",
                                            "bairro"
                                        )}
                                    </div>
                                </div>

                                {renderCampo(
                                    "Cidade",
                                    "cidade"
                                )}

                                <div className="linha-dupla">
                                    <div className="campo-estado">
                                        {renderCampo(
                                            "Estado",
                                            "estado"
                                        )}
                                    </div>

                                    <div className="campo-pais">
                                        {renderCampo(
                                            "País",
                                            "pais"
                                        )}
                                    </div>
                                </div>

                               

                                {renderCampo(
                                    "Email",
                                    "email"
                                )}

                            </div>

                        </div>

                        {mensagem && (

                            <div
                                className={`mensagem ${tipoMensagem}`}
                            >
                                {mensagem}
                            </div>

                        )}

                        {!editando ? (

                            <button
                                className="primeiro-button"
                                onClick={handleEditar}
                            >
                                Editar
                            </button>

                        ) : (

                            <div className="dadoscliente-botoes">

                                <button
                                    className="primeiro-button"
                                    onClick={salvar}
                                >
                                    Solicitar Alteração
                                </button>

                                <button
                                    className="dadoscliente-cancelar"
                                    onClick={cancelar}
                                >
                                    Cancelar
                                </button>

                            </div>

                        )}

                    </div>

                </div>

            </div>

            <BTNtoTop />

            <Footer />

            <AlterarSenha
                aberto={modalSenha}
                onClose={() =>
                    setModalSenha(false)
                }
            />

        </>
    );
}